import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import FancyTitle from '../fancy-title';

export default function ChecklistBox({ blok }) {
  const {
    items,
    title,
    buttonLink,
    buttonText,
    titleColumnWidth,
    itemsColumnWidth
  } = blok;

  const listItems = items.content[0].content;

  return (
    <div className="bg-black py-[70px] px-8 lg:px-20 green-background-double">
      <div className="flex flex-col lg:flex-row items-center gap-x-20 z-1 relative">
        <div {...(titleColumnWidth && { customStyleOverrides: { flex: `0 0 ${titleColumnWidth}%` } })}>
          <FancyTitle
            text={title}
            textAlign="text-left"
            className="mx-auto text-white"
            marginBottom="mb-0"
            tag="h2"
          />

          <a className="uppercase button-primary mt-10 w-max hidden lg:block" href={`/${buttonLink.story?.full_slug}`}>
            {buttonText}
          </a>
        </div>
        <div className="flex-column flex" {...(itemsColumnWidth && { style: { flex: `0 0 ${itemsColumnWidth}%` } })}>
          {items && (
            <ul className="flex flex-col gap-y-16">
              { listItems.map((listItem) => (
                <li className="text-white flex gap-x-8 items-center">
                  <StaticImage
                    className="aspect-square object-cover min-w-[30px]"
                    layout="fixed"
                    formats={['auto', 'webp', 'avif']}
                    src="../../images/checkbox.svg"
                    width={30}
                    height={30}
                    alt="Checkbox Icon"
                  />
                  <div>
                    <p className="text-2xl font-normal">
                      {listItem.content[0].content[0].text.split('//')[0]}
                    </p>
                    <span className="text-sm mt-[20px] font-light block">
                      {listItem.content[0].content[0].text.split('//')[1]}
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className="w-full flex z-1 relative justify-center lg:justify-start lg:hidden">
        <a className="uppercase button-primary mt-20 w-max" href={`/${buttonLink.story?.full_slug}`}>
          {buttonText}
        </a>
      </div>
    </div>
  );
}
